import React, { useState, useEffect } from 'react';
import { motion, useMotionValue, useScroll, useSpring, useTransform } from 'framer-motion';
import './Navbar.css'; // Custom styles if needed
import logo from '../../assets/images/logopng.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope, faBars } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';

function containedBarWidth(viewport) {
    if (viewport >= 1400) return 1320;
    if (viewport >= 1200) return 1140;
    if (viewport >= 992) return 960;
    if (viewport >= 768) return 720;
    if (viewport >= 576) return 540;
    return viewport;
}

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { scrollY } = useScroll();
    const collapsedWidth = useMotionValue(containedBarWidth(window.innerWidth));
    const fullWidth = useMotionValue(window.innerWidth);

    useEffect(() => {
        const measure = () => {
            const viewport = window.innerWidth;
            fullWidth.set(viewport);
            collapsedWidth.set(Math.min(containedBarWidth(viewport), viewport));
        };

        measure();
        window.addEventListener('resize', measure);
        return () => window.removeEventListener('resize', measure);
    }, [collapsedWidth, fullWidth]);

    const extendProgress = useSpring(
        useTransform(scrollY, [0, 160], [0, 1], { clamp: true }),
        { stiffness: 110, damping: 24, mass: 0.7 }
    );
    const barWidth = useTransform(
        [extendProgress, collapsedWidth, fullWidth],
        ([progress, collapsed, full]) => {
            const t = Math.min(Math.max(progress, 0), 1);
            return collapsed + (full - collapsed) * t;
        }
    );
    const barRadius = useTransform(extendProgress, (progress) => {
        const t = Math.min(Math.max(progress, 0), 1);
        return 10 * (1 - t);
    });

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <>
       
        <motion.div className="navbarcont" style={{ width: barWidth }}>
       
            <motion.nav className="navbar navbar-expand-md" style={{ borderRadius: barRadius }}>
                <div className="container">
           
                    <a className="navbar-brand" href="/">
                        <img src={logo} alt="Company Logo" />
                    </a>
                    
                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={toggleMenu}
                        aria-controls="navbarNav"
                        aria-expanded={isMenuOpen}
                        aria-label="Toggle navigation"
                    >
                        <FontAwesomeIcon icon={faBars} />
                    </button>
                  
                
                    <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item"><a className="nav-link" href="/">Home</a></li>
                            <li className="nav-item"><a className="nav-link" href="/aboutus">About</a></li>
                            <li className="nav-item"><a className="nav-link" href="/service">Service</a></li>
                            <li className="nav-item"><a className="nav-link" href="/internship">Internship</a></li>
                            <li className="nav-item"><a className="nav-link" href="#">Blog</a></li>
                            <li className="nav-item"><a className="nav-link" href="contactus">Contact</a></li>
                                <li className="nav-item"><a className="btn btn-primary ml-md-3" href="contactus">Get a Support</a></li>
                        </ul>
                    </div>
                </div>
            </motion.nav>
        </motion.div>
        </>
    );
};

export default Navbar;
